import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  BootstrapVue,
  BootstrapVueIcons
} from 'bootstrap-vue'
import jQuery from 'jquery'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueCryptojs from 'crypto-js';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import loading from 'vuejs-loading-screen'
import moment from "moment";
import VCalendar from 'v-calendar';

import VueAnalytics from 'vue-analytics'
import VueHorizontalCalendar from 'vue-horizontal-calendar';
import DraggableCal from 'vue-draggable-cal';
// import VueQRCodeComponent from 'vue-qr-generator'
// Vue.component(VueQRCodeComponent)
// import VueQrcodeReader from "vue-qrcode-reader";

// Vue.use(VueQrcodeReader);
import VueQRCodeComponent from 'vue-qrcode-component'
import VueSignaturePad from 'vue-signature-pad';
import * as VueGoogleMaps from 'vue2-google-maps';



Vue.use(VueGoogleMaps,{
  // AIzaSyAkHz2SsDjR2YQgqeLcsbjOZgp_JqraMNU
  load: {
    key: '', // Replace with your Google Maps API key
     libraries: 'places,drawing,visualization'
  },
});
Vue.use(VueSignaturePad);

// import Multiselect from 'vue-multiselect'
// import './assets/font/Sarabun-Regular-normal.js';
Vue.component('qr-code', VueQRCodeComponent)

Vue.use(VueAnalytics, {
  id: '280445880'
})
Vue.use(VCalendar);
// Vue.use(Multiselect);
// Vue.use(VCalendar, {
//   // ...some defaults
//   screens: {
//     tablet: '576px',
//     laptop: '992px',
//     desktop: '1200px',
//   },
//   // ...other defaults
// })

Vue.use(moment);
Vue.use(VueHorizontalCalendar);
Vue.use(DraggableCal);
Vue.use(loading, {
  bg: '#f9f5f453',
  slot: `
    <div class="px-5 py-3 bg-gray-800 rounded">
      <h3 class="text-3xl text-white"><i class="fas fa-spinner fa-spin" style="color:red;"></i></h3>
    </div>
  `
})

global.jQuery = jQuery
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueAxios, axios)
// Vue.use(axios)
Vue.use(VueCryptojs)

// Vue.prototype.$http = axios;
const token = localStorage.getItem('access_token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

// Vue.use(VueFbCustomerChat, {
//   page_id: 276993842745052, //  change 'null' to your Facebook Page ID,
//   theme_color: '#333333', // theme color in HEX
//   locale: 'th_TH', // default 'en_US'
// })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')